import React, { PropsWithChildren } from 'react';
import { Nav, NavItem } from 'react-bootstrap';
import { WizardProvider, useWizard, WizardStepShape, WizardStepKey } from './useWizard';
import './Wizard.scss';
import { Icon } from '../Icon/Icon';

export interface WizardProps extends PropsWithChildren<any> {
    initialStep?: WizardStepKey;
    activeStep?: WizardStepKey;
    onStepChange?: (nextStepId: WizardStepKey) => void;
}

export function Wizard(props: WizardProps) {

    return (
        <WizardProvider initialStep={props.initialStep} activeKey={props.activeStep}>
            <WizardSteps onStepChange={props.onStepChange}>
                {props.children}
            </WizardSteps>
        </WizardProvider>
    )
}

(Wizard as any).displayName = 'Wizard';

export function WizardSteps({ children, onStepChange }: any) {
    const { activeStep, steps, gotoStep } = useWizard();

    function onSelectStep(e: any) {
        gotoStep(e);
        if (typeof onStepChange === 'function') {
            onStepChange(e);
        }
            
    }

    function getStepIcon(step: WizardStepShape) {
        if (!step) return null;

        if (step.done) {
            return <Icon glyph="ok-sign" />
        } else if (step.eventKey === activeStep) {
            return <Icon glyph="edit" />
        }

        return <Icon glyph="edit" />;
    }

    return (
        <div className="wizard-container">
            <div className="wizard-nav-container">
                <Nav activeKey={activeStep} role="tablist" as="nav" onSelect={onSelectStep}>
                    {steps.map(step => 
                        <NavItem eventKey={step.eventKey} key={step.eventKey} className={step.done ? 'done' : undefined} disabled={step.disabled}>
                            {getStepIcon(step)}{' '}{step.name}
                        </NavItem>
                    )}
                </Nav>
            </div>
            <div className="wizard-step-container">
                {children}
            </div>
        </div>
    )
}

(WizardSteps as any).displayName = 'WizardSteps';